import React from "react"
import { observer, useLocalObservable } from "mobx-react"
import { Flex } from "antd"

import { BankDetailsCollection } from "@src/pages/settingsBankDetails/classes/BankDetailsCollection"
import { BanksDetailFormRedirect } from "@src/pages/settingsBankDetails/ui/BanksDetailFormRedirect"
import { BanksDetailTable } from "@src/pages/settingsBankDetails/ui/BanksDetailTable"

export const SettingsBankDetailsPage = observer(() => {
  const banks = useLocalObservable(() => new BankDetailsCollection())

  return (
    <Flex gap={32} vertical>
      <BanksDetailFormRedirect />
      {(!banks.isEmpty || banks.isLoading) && (
        <BanksDetailTable collection={banks} />
      )}
    </Flex>
  )
})
